import { Button } from "@mui/material";
import { useState } from "react";
import SetMaximumExtendPeriodModal from "../modals/SetMaximumExtendPeriodModal";
import { Settings } from "@mui/icons-material";

export default function SetMaximumExtendPeriodButton() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button startIcon={<Settings />} variant="contained" onClick={handleOpen}>
        Set Maximum Extend Period
      </Button>
      <SetMaximumExtendPeriodModal open={open} onClose={handleClose} />
    </>
  );
}
